__turbopack_context__.v({
  "table": "table-module__5GGgVW__table",
});
